// constants/newsData.js
import new1 from "../../assets/newpage/newpage1.webp";
import new2 from "../../assets/newpage/newpage2.jpg";
import new3 from "../../assets/newpage/newpage3.jpg";
import new4 from "../../assets/newpage/moi-gioi-bat-dong-san.jpg";
import new5 from "../../assets/newpage/newpage5.jpg";
import new6 from "../../assets/newpage/newpage6.jpg";
import backgroundImage from "../../assets/news-blog.jpg";

export { backgroundImage };

export const mockBlogs = [
  { id: 1, title: "Thị trường bất động sản Hà Nội năm 2025", excerpt: "Phân tích xu hướng giá cả và cơ hội đầu tư tại các quận trung tâm.", image: new1, link: "/news/1" },
  { id: 2, title: "Kinh nghiệm chọn căn hộ phù hợp", excerpt: "Những tiêu chí quan trọng khi mua căn hộ chung cư để ở hoặc đầu tư.", image: new2, link: "/news/2" },
  { id: 3, title: "Biệt thự ven đô: Xu hướng đầu tư mới", excerpt: "Tại sao biệt thự ven đô đang trở thành lựa chọn ưa chuộng của giới nhà giàu?", image: new3, link: "/news/3" },
  { id: 4, title: "Lợi ích khi sử dụng dịch vụ môi giới chuyên nghiệp", excerpt: "Tăng hiệu quả giao dịch và giảm rủi ro khi mua bán bất động sản.", image: new4, link: "/news/4" },
  { id: 5, title: "Xu hướng thiết kế nội thất 2025", excerpt: "Những phong cách nội thất đang được ưa chuộng trong các dự án mới.", image: new5, link: "/news/5" },
  { id: 6, title: "Thị trường bất động sản công nghiệp tại Việt Nam 2025", excerpt: "Cơ hội đầu tư vào khu công nghiệp, kho bãi và logistics trong năm tới.", image: new6, link: "/news/6" },
];

const baseUrl = typeof window !== "undefined" ? window.location.href : "https://vinhomesdemo.com/news";
const origin = typeof window !== "undefined" ? window.location.origin : "https://vinhomesdemo.com";

export const newsSeoData = {
  title: "Tin tức & Blog Bất động sản - Mỹ Diệp Property",
  description: "Cập nhật thông tin mới nhất về thị trường bất động sản, dự án, xu hướng đầu tư và thiết kế nội thất.",
  keywords: "bất động sản, tin tức, blog, đầu tư, dự án, nội thất",
  image: backgroundImage,
  type: "website",
  url: baseUrl,
  schema: {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Tin tức & Blog Bất động sản",
    url: baseUrl,
    description: "Cập nhật thông tin mới nhất về thị trường bất động sản, dự án, xu hướng đầu tư và nội thất.",
    blogPost: mockBlogs.map((blog) => ({
      "@type": "BlogPosting",
      headline: blog.title,
      image: blog.image,
      url: origin + blog.link,
      description: blog.excerpt,
      datePublished: "2025-11-12",
    })),
  },
};